module.exports = __webpack_public_path__ + "img/carlos.531969da.jpg";